export default {"src":"/_next/static/media/home-heart-arms.1a886635.svg","height":84,"width":115,"blurWidth":0,"blurHeight":0};